import {
  reactQueryGet,
  reactQueryPatch,
  reactQueryPost,
} from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import type { AccessGroupType, ChecklistData } from "@/react/types";

const show = () =>
  reactQueryGet<ChecklistData>(internalApi.communities.checklist.show());

const update = (params: Partial<ChecklistData>) =>
  reactQueryPatch<ChecklistData, { checklist: Partial<ChecklistData> }>(
    internalApi.communities.checklist.update(),
    { checklist: params },
  );

const defaultAccessGroup = () =>
  reactQueryPost<AccessGroupType>(
    internalApi.communities.checklist.defaultAccessGroup(),
  );

const broadcast = () =>
  reactQueryGet<{ broadcast_id: number }>(
    internalApi.communities.checklist.broadcast(),
  );

export const checklistsApi = {
  show,
  update,
  broadcast,
  defaultAccessGroup,
};
